import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { Request } from 'commons/utils/request'
import { IconName, Toast } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/components/Dialog/ConfirmationDialogV2'

import { useHRRContext } from '../../context'

export const Actions = () => {
  const { data } = useHRRContext()
  const { titleOverline, highRiskReviewId, infoRelationshipId } = data
  const confirmation = useConfirmation()
  const navigate = useNavigate()

  const { mutate } = useMutation<void, Error, { id: number }>({
    mutationFn: (opts) => Request.delete(Request.urls.bank.hrr, opts),
    onSuccess: () => {
      Toast.successSmall(`${titleOverline} was deleted`)
      navigate({ to: routes.bank.relationships.details, params: { id: infoRelationshipId.toString() } })
    }
  })

  const handleDelete = async () => {
    await confirmation.showDeleteConfirmation({
      message: `Are you sure you want to delete ${titleOverline}?`,
      submitButtonText: 'Delete',
      confirmCallback: async () => mutate({ id: highRiskReviewId })
    })
  }

  return (
    <IconButton face="neutral" icon={IconName.DELETE} onClick={handleDelete}>
      Delete
    </IconButton>
  )
}
